import React from 'react';
import { BONUS_PRICE } from '../../../constants/defaults';

const TieredPricingLoader = () => {
  return (
    <div id="price-results" className="price-results prices-dynamic">
      <div className="sc-loader">
        <img
          src="/content/images/loader/loading.gif"
          alt="loader"
          className="center"
          role="status"
          aria-live="polite"
        />
      </div>
      <div className="loc-list loc-list--loading">
        <div className="pharmacy-item--loading">
          <div className="pharmacy-item__meta">
            <h4 className="pharmacy-item__name"> </h4>
            <p className="pharmacy-item__price" />
          </div>
          <p className="pharmacy-item__cta">
            <span
              role="link"
              id="price-result-04"
              className="sc-btn-green rx-get-this-price sc-member"
            />
          </p>
        </div>
        <div className="pharmacy-item--loading">
          <div className="pharmacy-item__meta">
            <h4 className="pharmacy-item__name"> </h4>
            <p className="pharmacy-item__price" />
          </div>
          <p className="pharmacy-item__cta">
            <span
              role="link"
              id="price-result-04"
              className="sc-btn-green rx-get-this-price sc-member"
            />
          </p>
        </div>
        <div className="pharmacy-item--loading">
          <div className="pharmacy-item__meta">
            <h4 className="pharmacy-item__name"> </h4>
            <p className="pharmacy-item__price" />
          </div>
          <p className="pharmacy-item__cta">
            <span
              role="link"
              id="price-result-04"
              className="sc-btn-green rx-get-this-price sc-member"
            />
          </p>
        </div>
      </div>

      <div className="loc-list hidden">
        <div>
          <div className="pharmacy-item__banner">
            <span className="banner-5off">Extra ${BONUS_PRICE} off</span>
          </div>
          <div className="pharmacy-item__details">
            <div className="pharmacy-item__meta">
              <div className="pharmacy-item__location">
                <h4 className="pharmacy-item__name">Placeholder</h4>
                <p className="pharmacy-item__distance">
                  Placeholder<span className="miles">miles away</span>
                </p>
                <p className="pharmacy-item__distance">
                  &lt; 0.1 <span className="miles">miles away</span>
                </p>
              </div>

              <div className="pharmacy-item__price">
                <p className="price-promo">Placeholder</p>
                <p className="price-original">Placeholdere</p>
              </div>
            </div>
            <p className="pharmacy-item__cta">
              <button role="link">Get free coupon</button>
            </p>
          </div>
          <div className="pharmacy-item__pricing-msg">
            <p>
              <span>
                ${BONUS_PRICE} off only applies on first prescription filled at
                __Placeholder__ using SingleCare.
              </span>
            </p>
            <p>
              <span>
                CVS cards must be used at CVS pharmacies. Not valid at any other
                pharmacy.
              </span>
            </p>
            <p>
              <span>
                Walmart cards must be used at Walmart pharmacies. Not valid at
                any other pharmacy.
              </span>
            </p>
            <p>
              <span>Walgreens cards must be used at Walgreens pharmacies.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TieredPricingLoader;
